import { styled } from 'styled-components';

export const TooltipWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const MessageAndDateWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;

  & > div:last-child {
    text-align: right;
  }
`;
